import { render } from "./CorrectionReportLoansTable.vue?vue&type=template&id=e81aadba"
import script from "./CorrectionReportLoansTable.vue?vue&type=script&lang=js"
export * from "./CorrectionReportLoansTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__